export default __webpack_public_path__ + "static/media/all-leaf-no-beef.8b5c8be1.gif";